import { isGuid } from 'src/app/_helpers/guid.helper';

/**
 * Helpers for custom field utilities
 */

/**
 * Custom field keys are the entity primary key prefixed with "f_".
 * After the long-to-Guid PK migration the id is a GUID (f_<guid>); legacy
 * environments may still carry the pre-migration numeric form (f_<int>).
 * Both are accepted so custom-field values are recognized either way.
 */
const CUSTOM_FIELD_KEY_REGEX =
  /^f_([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}|\d+)$/;

/**
 * Check if a string is a custom field key (f_<guid> or legacy f_<int>)
 * @param key - The key to validate
 * @returns true if the key matches the custom field pattern
 */
export function isCustomFieldKey(key: string): boolean {
  return !!key && CUSTOM_FIELD_KEY_REGEX.test(key);
}

/**
 * Parse a default value string based on its declared type
 * @param value - The string value to parse
 * @param type - The target type: 'number', 'enum', 'boolean', 'object', or 'string'
 * @returns The parsed value, or null if parsing fails for numeric types
 */
export function parseDefaultValue(value: string, type: string): string | number | boolean | null {
  switch (type) {
    case 'object':
      return isGuid(value) ? value.toLowerCase() : null;
    case 'number':
    case 'enum': {
      const num = Number(value);
      return isNaN(num) ? null : num;
    }
    case 'boolean':
      return value.toLowerCase() === 'true';
    default:
      return value;
  }
}
